export const brands = [
  {
    name: "3MF",
    slug: "3mf",
    image: "/assets/brands/3mf.webp",
    categories: ["Refrigeration-line", "Snack Maker"],
  },
  {
    name: "Ailipu",
    slug: "ailipu",
    image: "/assets/brands/ailipu-1.webp",
    categories: ["Cooking"],
  },
  {
    name: "Alto-Shaam",
    slug: "alto-shaam",
    image: "/assets/brands/Alto-Shaam.webp",
    categories: ["Cooking"],
  },
  {
    name: "Anfim",
    slug: "anfim",
    image: "/assets/brands/anfilm.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "APW Wyott",
    slug: "apw-wyott",
    image: "/assets/brands/apwwyott.webp",
    categories: ["Bakery", "Snack Maker"],
  },
  {
    name: "Asaki",
    slug: "asaki",
    image: "/assets/brands/asaki-logo.webp",
    categories: ["Coffee & Bar", "Food Processing"],
  },
  {
    name: "Battistella",
    slug: "battistella",
    image: "/assets/brands/BATTISTELLA-1.webp",
    categories: ["Super Market"],
  },
  {
    name: "Berjaya",
    slug: "berjaya",
    image: "/assets/brands/Berjaya-Logo.webp",
    categories: ["Super Market"],
  },
  {
    name: "Bilait",
    slug: "bilait",
    image: "/assets/brands/BILAIT-Logo.webp",
    categories: ["Snack Maker"],
  },
  {
    name: "Bimatic",
    slug: "bimatic",
    image: "/assets/brands/bimatic.webp",
    categories: ["Cooking"],
  },
  {
    name: "Blendtec",
    slug: "blendtec",
    image: "/assets/brands/Blendec-logo.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Brema",
    slug: "brema",
    image: "/assets/brands/brema.webp",
    categories: ["Refrigeration-line"],
  },
  {
    name: "Bunn",
    slug: "bunn",
    image: "/assets/brands/bunn.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Camry",
    slug: "camry",
    image: "/assets/brands/camry.webp",
    categories: ["Super Market"],
  },
  {
    name: "Capinox",
    slug: "capinox",
    image: "/assets/brands/capinox.webp",
    categories: ["Bakery", "Food Processing"],
  },
  {
    name: "Cofrimell",
    slug: "cofrimell",
    image: "/assets/brands/cofrimell.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Desmon",
    slug: "desmon",
    image: "/assets/brands/desmon.webp",
    categories: ["Refrigeration-line"],
  },
  {
    name: "Easyline",
    slug: "easyline",
    image: "/assets/brands/easyline.webp",
    categories: [
      "Cooking",
      "Coffee & Bar",
      "Food Processing",
      "Dry Store",
    ],
  },
  {
    name: "Electrolux",
    slug: "electrolux",
    image: "/assets/brands/electrolux.webp",
    categories: [],
  },
  {
    name: "Empero",
    slug: "empero",
    image: "/assets/brands/empero.webp",
    categories: [
      "Cooking",
      "Refrigeration-line",
      "Coffee & Bar",
      "Bakery",
      "Food Processing",
      "Snack Maker",
      "Dish Washer",
      "Dry Store",
    ],
  },
  {
    name: "Fagor",
    slug: "fagor",
    image: "/assets/brands/FagorProfesional.webp",
    categories: ["Dish Washer"],
  },
  {
    name: "Ace Filters",
    slug: "ace-filters",
    image: "/assets/brands/Falater.webp",
    categories: [],
  },
  {
    name: "Fimar",
    slug: "fimar",
    image: "/assets/brands/fimar.webp",
    categories: [
      "Cooking",
      "Coffee & Bar",
      "Food Processing",
    ],
  },
  {
    name: "Frymaster",
    slug: "frymaster",
    image: "/assets/brands/FRYMASTER.webp",
    categories: ["Cooking"],
  },
  {
    name: "Gelmatic",
    slug: "gelmatic",
    image: "/assets/brands/gelmatic.webp",
    categories: ["Refrigeration-line"],
  },
  {
    name: "GGF",
    slug: "ggf",
    image: "/assets/brands/ggf-logo.webp",
    categories: ["Cooking", "Bakery"],
  },
    {
    name: "GHS",
    slug: "ghs",
    image: "/assets/brands/ghs.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Grindmaster",
    slug: "grindmaster",
    image: "/assets/brands/grindmaster.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Hatco",
    slug: "hatco",
    image: "/assets/brands/hacto.webp",
    categories: ["Cooking"],
  },
  {
    name: "Hamilton Beach",
    slug: "hamilton-beach",
    image: "/assets/brands/hamilton-logo.webp",
    categories: [
      "Cooking",
      "Coffee & Bar",
      "Bakery",
    ],
  },
  {
    name: "Henny Penny",
    slug: "henny-penny",
    image: "/assets/brands/hennypenny.webp",
    categories: ["Cooking"],
  },
  {
    name: "Hoonved",
    slug: "hoonved",
    image: "/assets/brands/hoonved.webp",
    categories: ["Dish Washer"],
  },
  {
    name: "Hoshizaki",
    slug: "hoshizaki",
    image: "/assets/brands/hoshizaki.webp",
    categories: ["Refrigeration-line"],
  },
  {
    name: "Imesa",
    slug: "imesa",
    image: "/assets/brands/imesa.webp",
    categories: ["Dish Washer"],
  },
  {
    name: "Imperial",
    slug: "imperial",
    image: "/assets/brands/IMPERIAL.webp",
    categories: [],
  },
  {
    name: "Infrico",
    slug: "infrico",
    image: "/assets/brands/inofrigo.webp",
    categories: [
      "Refrigeration-line",
      "Bakery",
    ],
  },
  {
    name: "Josper",
    slug: "josper",
    image: "/assets/brands/josper.webp",
    categories: ["Cooking"],
  },
  {
    name: "KitchenAid",
    slug: "kitchenaid",
    image: "/assets/brands/Kitchen-Aid.webp",
    categories: ["Bakery"],
  },
  {
    name: "La Marzocco",
    slug: "la-marzocco",
    image: "/assets/brands/La-Marzocco.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "La Minerva",
    slug: "la-minerva",
    image: "/assets/brands/LA-MINERVA.webp",
    categories: ["Food Processing"],
  },
  {
    name: "La Cimbali",
    slug: "la-cimbali",
    image: "/assets/brands/lacimbali.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Miska",
    slug: "miska",
    image: "/assets/brands/Logo-MiskaFoodTechnology1.webp",
    categories: ["Food Processing"],
  },
  {
    name: "Longoni",
    slug: "longoni",
    image: "/assets/brands/Longoni-Brand.webp",
    categories: ["Bakery"],
  },
  {
    name: "Mac.Pan",
    slug: "mac-pan",
    image: "/assets/brands/macpac.webp",
    categories: ["Bakery"],
  },
  {
    name: "Mahlkonig",
    slug: "mahlkonig",
    image: "/assets/brands/MAHLKONIG-vector-logo.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Mariot",
    slug: "mariot",
    image: "/assets/brands/mariot.webp",
    categories: [
      "Refrigeration-line",
      "Coffee & Bar",
      "Food Processing",
      "Snack Maker",
      "Super Market",
      "Dry Store",
    ],
  },
  {
    name: "MBM",
    slug: "mbm",
    image: "/assets/brands/mbm-logo.webp",
    categories: [
      "Cooking",
      "Bakery",
      "Dish Washer",
    ],
  },
  {
    name: "Menumaster",
    slug: "menumaster",
    image: "/assets/brands/menumaster.webp",
    categories: [
      "Cooking",
      "Bakery",
    ],
  },
  {
    name: "Merrychef",
    slug: "merrychef",
    image: "/assets/brands/merrychef.webp",
    categories: [],
  },
  {
    name: "Middleby Marshall",
    slug: "middleby-marshall",
    image: "/assets/brands/middleby-marshall-logo.webp",
    categories: ["Cooking"],
  },
  {
    name: "MKE-Matic",
    slug: "mke-matic",
    image: "/assets/brands/mke-logo.webp",
    categories: [
      "Refrigeration-line",
      "Coffee & Bar",
    ],
  },
  {
    name: "Moel",
    slug: "moel",
    image: "/assets/brands/moel.webp",
    categories: ["Dry Store"],
  },
  {
    name: "Monolith",
    slug: "monolith",
    image: "/assets/brands/monolith.webp",
    categories: [],
  },
    {
    name: "Mussana",
    slug: "mussana",
    image: "/assets/brands/mussana.webp",
    categories: [],
  },
  {
    name: "Nuova Simonelli",
    slug: "nuova-simonelli",
    image: "/assets/brands/simonelli.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Omega",
    slug: "omega",
    image: "/assets/brands/Omega.webp",
    categories: ["Food Processing"],
  },
  {
    name: "Oztiryakiler",
    slug: "oztiryakiler",
    image: "/assets/brands/oztriyakiler.webp",
    categories: [
      "Cooking",
      "Dish Washer",
    ],
  },
  {
    name: "Pastaline",
    slug: "pastaline",
    image: "/assets/brands/pastaline.webp",
    categories: ["Bakery"],
  },
  {
    name: "Pitco",
    slug: "pitco",
    image: "/assets/brands/pitco.webp",
    categories: ["Cooking"],
  },
  {
    name: "POSLIX",
    slug: "poslix",
    image: "/assets/brands/poslix.webp",
    categories: ["Super Market"],
  },
  {
    name: "Prince Castle",
    slug: "prince-castle",
    image: "/assets/brands/prince-casle.webp",
    categories: [],
  },
  {
    name: "Rancilio",
    slug: "rancilio",
    image: "/assets/brands/Rancilio-logo-1.webp",
    categories: [],
  },
  {
    name: "Rational",
    slug: "rational",
    image: "/assets/brands/rational.webp",
    categories: ["Cooking"],
  },
  {
    name: "Red Fox",
    slug: "red-fox",
    image: "/assets/brands/redfox.webp",
    categories: [
      "Cooking",
      "Bakery",
    ],
  },
  {
    name: "Robot Coupe",
    slug: "robot-coupe",
    image: "/assets/brands/robotcoupe.webp",
    categories: [
      "Coffee & Bar",
      "Bakery",
      "Food Processing",
    ],
  },
  {
    name: "Roller Grill",
    slug: "roller-grill",
    image: "/assets/brands/roller-grill.webp",
    categories: [
      "Cooking",
      "Refrigeration-line",
      "Bakery",
      "Snack Maker",
    ],
  },
  {
    name: "Rotondi Group",
    slug: "rotondi-group",
    image: "/assets/brands/Rotondi-Group.webp",
    categories: [],
  },
  {
    name: "SAB",
    slug: "sab",
    image: "/assets/brands/sab.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Salva",
    slug: "salva",
    image: "/assets/brands/salva.webp",
    categories: ["Cooking"],
  },
  {
    name: "Samixir",
    slug: "samixir",
    image: "/assets/brands/samixir.webp",
    categories: [
      "Cooking",
      "Coffee & Bar",
    ],
  },
  {
    name: "Santos",
    slug: "santos",
    image: "/assets/brands/santos.webp",
    categories: [
      "Coffee & Bar",
      "Food Processing",
    ],
  },
  {
    name: "SAP",
    slug: "sap",
    image: "/assets/brands/sap-bone-saw-machine-in-dubai.webp",
    categories: ["Food Processing"],
  },
  {
    name: "Scotsman",
    slug: "scotsman",
    image: "/assets/brands/Logo-1.webp",
    categories: [],
  },
  {
    name: "Server",
    slug: "server",
    image: "/assets/brands/server.webp",
    categories: ["Cooking"],
  },
  {
    name: "Sheffield",
    slug: "sheffield",
    image: "/assets/brands/Sheffiel.webp",
    categories: ["Snack Maker"],
  },
  {
    name: "Snooker",
    slug: "snooker",
    image: "/assets/brands/snooker-1.webp",
    categories: ["Refrigeration-line"],
  },
  {
    name: "Sofinor",
    slug: "sofinor",
    image: "/assets/brands/sofinor.webp",
    categories: [
      "Food Processing",
      "Dry Store",
    ],
  },
  {
    name: "Southbend",
    slug: "southbend",
    image: "/assets/brands/southbend.webp",
    categories: ["Cooking"],
  },
  {
    name: "Spaceman",
    slug: "spaceman",
    image: "/assets/brands/20210329_Spaceman-Logo_Black.webp",
    categories: [],
  },
  {
    name: "Speed Queen",
    slug: "speed-queen",
    image: "/assets/brands/Speed-Queen.webp",
    categories: [],
  },
  {
    name: "Star",
    slug: "star",
    image: "/assets/brands/star.webp",
    categories: [
      "Cooking",
      "Coffee & Bar",
      "Snack Maker",
    ],
  },
    {
    name: "Stilco",
    slug: "stilco",
    image: "/assets/brands/stilco1.webp",
    categories: [
      "Cooking",
      "Refrigeration-line",
      "Bakery",
      "Snack Maker",
    ],
  },
  {
    name: "Technocooler",
    slug: "technocooler",
    image: "/assets/brands/technocooler.webp",
    categories: [
      "Refrigeration-line",
      "Bakery",
    ],
  },
  {
    name: "Tecnodom",
    slug: "tecnodom",
    image: "/assets/brands/tecnodom.webp",
    categories: [
      "Refrigeration-line",
      "Bakery",
      "Super Market",
    ],
  },
  {
    name: "Toastmaster",
    slug: "toastmaster",
    image: "/assets/brands/Toastmaster.webp",
    categories: [],
  },
  {
    name: "TurboChef",
    slug: "turbochef",
    image: "/assets/brands/turbo-chef.webp",
    categories: ["Cooking"],
  },
  {
    name: "Ubermilk",
    slug: "ubermilk",
    image: "/assets/brands/uebermilk_logo_small.webp",
    categories: [],
  },
  {
    name: "Union",
    slug: "union",
    image: "/assets/brands/Union.webp",
    categories: [],
  },
  {
    name: "Unox",
    slug: "unox",
    image: "/assets/brands/unox.webp",
    categories: [
      "Cooking",
      "Bakery",
    ],
  },
  {
    name: "Venarro",
    slug: "venarro",
    image: "/assets/brands/venarro.webp",
    categories: ["Bakery"],
  },
  {
    name: "Venix",
    slug: "venix",
    image: "/assets/brands/venix.webp",
    categories: [
      "Cooking",
      "Bakery",
    ],
  },
  {
    name: "Vitamix",
    slug: "vitamix",
    image: "/assets/brands/vitamix.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "VITO",
    slug: "vito",
    image: "/assets/brands/VITO-OIL-FILTER-SYSTEM.webp",
    categories: ["Cooking"],
  },
  {
    name: "Vulcan",
    slug: "vulcan",
    image: "/assets/brands/VULCAN-BRAND.webp",
    categories: ["Cooking"],
  },
  {
    name: "Waring",
    slug: "waring",
    image: "/assets/brands/warning.webp",
    categories: [
      "Cooking",
      "Coffee & Bar",
      "Food Processing",
    ],
  },
  {
    name: "Zemic Europe",
    slug: "zemic-europe",
    image: "/assets/brands/Zemic-Europe.webp",
    categories: ["Coffee & Bar"],
  },
  {
    name: "Zmatik",
    slug: "zmatik",
    image: "/assets/brands/zmatik-1.webp",
    categories: ["Dry Store"],
  },
  {
    name: "Zumex",
    slug: "zumex",
    image: "/assets/brands/Zumex.webp",
    categories: ["Coffee & Bar"],
  },
];